import React from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { parse } from 'qs';

import { useRootContext } from '@/store/RootContext';
import { Loader } from '@/component/Loader';
import { FORCE_SSO_LOGIN_KEY } from '@/utils/constants';
import { isRealm } from '@/utils/realms';
import { ROUTE_PATH } from '@/constants/routePaths';

export const AuthenticatedRoute = (): JSX.Element => {
  const { isAuthenticated, acceptedPrivacy, acceptedTos, acceptedExtraTerms, loading } = useRootContext();
  const location = useLocation();
  const navigate = useNavigate();
  const query = parse(location.search, { ignoreQueryPrefix: true });
  const loginSearchParams = new URLSearchParams({
    returnUrl: `${window.location.origin}${location.pathname}${location.search}`,
  });

  if (query[FORCE_SSO_LOGIN_KEY]) {
    loginSearchParams.set(FORCE_SSO_LOGIN_KEY, 'true');
  }

  const needsToAcceptExtraTerms = isRealm('kompetens') && !acceptedExtraTerms;
  const needsOnboarding =
    isAuthenticated &&
    (!acceptedTos || !acceptedPrivacy || needsToAcceptExtraTerms) &&
    location.pathname !== ROUTE_PATH.ONBOARDING;

  if (loading) return <Loader />;

  if (!isAuthenticated)
    return (
      <Navigate
        replace
        to={{
          pathname: ROUTE_PATH.LOGIN,
          search: `?${loginSearchParams.toString()}`,
        }}
        state={{ from: location }}
      />
    );

  if (needsOnboarding) return <Navigate replace to={ROUTE_PATH.ONBOARDING} />;

  if (query[FORCE_SSO_LOGIN_KEY]) {
    const otherSearchParamsPresent = Object.keys(query).length > 1;
    const search = otherSearchParamsPresent ? location.search.replace(`${FORCE_SSO_LOGIN_KEY}=true`, '') : '';
    navigate(
      {
        search,
      },
      { replace: true },
    );
  }
  return <Outlet />;
};
